import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { getClassName } from "ui-kit/utils/component";
import { get } from "lodash";
import DateHelper from "utils/date";
import { getCurrencySymbol } from "utils/currencyHelper";

import "./Card.scss";

import icon1 from "./assets/images/icon1.png";
import icon2 from "./assets/images/icon2.png";
import icon3 from "./assets/images/icon3.png";
import { NavLink } from 'react-router-dom';
import cx from 'classnames';
import { getLang } from '../../../utils/language';
import { Button } from '../../../ui-kit/components';

const ccn = getClassName("Card");

const SingleCard = ({ title, icon, children }) => (
  <div className={ccn()}>
    <h2 className={ccn("title")}>
      {title}
    </h2>
    <img src={icon} className={ccn("icon")} alt="icon" />
    {children}
  </div>
);

const Card = ({ userInvest, userFid, userFcd, userBalance, intl: { formatMessage } }) => {
  const firstInvestDate = userFid ? new DateHelper(userFid) : null;
  const firstCommittedDate = userFcd ? new DateHelper(userFcd) : null;

  const balance = parseFloat(get(userBalance, "balance", null));
  const investAmount = parseFloat(get(userInvest, "amount", null));

  const showCommitedBalance = (balance === 0 || investAmount > 0 || (userBalance === null && userInvest === null));
  const showCurrentBalance = userBalance && userBalance.balance;
  const showDateFirstInvested = firstInvestDate && balance > 0;
  const showDateFirstCommited = firstCommittedDate && investAmount > 0;

  const isOneCard = !userInvest && !firstInvestDate && !firstCommittedDate;

  return (
    <React.Fragment>
      {showCommitedBalance && (
        <SingleCard
          icon={icon1}
          title={<FormattedMessage id="hbc.dashboard.left.title" defaultMessage="committed balance" />}
        >
          <p className={ccn("value")}>
            {userInvest && userInvest.currency && getCurrencySymbol(userInvest.currency)}
            {investAmount
              ? investAmount.toLocaleString("en-US", {
                maximumFractionDigits: get(userInvest, "currency") === "BTC" ? 8 : 2
              })
              : "0.00"
            } {get(userInvest, "currency", "USD")}
          </p>
          <p className={ccn("status")}>
            <FormattedMessage id="hbc.dashboard.status.waitlist" defaultMessage="Status: Waitlist" />
          </p>
        </SingleCard>
      )}
      {isOneCard && (
        <NavLink className={cx(ccn("column"), "CardButton")} to={`/${getLang()}/invest`}>
          <Button className="Button--invest">
            <FormattedMessage id="hbc.dashboard.invest" defaultMessage="invest" />
          </Button>
        </NavLink>
      )}
      {showCurrentBalance && (
        <SingleCard
          icon={icon3}
          title={<FormattedMessage id="hbc.dashboard.center.title" defaultMessage="current balance" />}
        >
          <p className={ccn("value with-date")}>
            {"$"}{balance.toLocaleString("en-US", {
              minimumFractionDigits: 2, maximumFractionDigits: 2
            })} {"USD"}
          </p>
          {userBalance.date && (
            <p className={ccn("date")}>
              <FormattedMessage id="hbc.dashboard.date" defaultMessage="as of " />
              {new DateHelper(userBalance.date).format("dd/mm/yyyy hh:MM*")}
            </p>
          )}
          {userBalance.balance !== 0 && (
            <p className={ccn("status")}>
              <FormattedMessage id="hbc.dashboard.status.invested" defaultMessage="Status: Invested" />
            </p>
          )}
        </SingleCard>
      )}
      { showDateFirstInvested ? (
        <SingleCard
          icon={icon2}
          title={<FormattedMessage id="hbc.dashboard.right.title.two" defaultMessage="date first invested" />}
        >
          <p className={ccn("value")}>
            {`${firstInvestDate.format("dd")} ${formatMessage({
              id: `hbc.dashboard.first.date.${firstInvestDate.format("mmm").toLowerCase()}`,
              defaultMessage: `${firstInvestDate.format("mmm")}`
            })} ${firstInvestDate.format("yyyy")}`}
          </p>
        </SingleCard>
      ) : showDateFirstCommited && (
        <SingleCard
          icon={icon2}
          title={<FormattedMessage id="hbc.dashboard.right.title" defaultMessage="date first committed" />}
        >
          <p className={ccn("value")}>
            {`${firstCommittedDate.format("dd")} ${formatMessage({
              id: `hbc.dashboard.first.date.${firstCommittedDate.format("mmm").toLowerCase()}`,
              defaultMessage: `${firstCommittedDate.format("mmm")}`
            })} ${firstCommittedDate.format("yyyy")}`}
          </p>
        </SingleCard>
      )}
    </React.Fragment>
  );
}

export default injectIntl(Card);



// WEBPACK FOOTER //
// ./src/containers/dashboard/card/Card.js